import { Component, OnInit, OnChanges, AfterViewInit, Output, EventEmitter, Input, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MapComponent } from './map/map.component';

@Component({
  selector: "app-map-view",
  templateUrl: "./map-view.component.html",
  styleUrls: ["./map-view.component.scss"],
})
export class MapViewComponent implements OnInit, OnChanges, AfterViewInit {
  @Output() listView = new EventEmitter<boolean>();
  @Output() switchMapLang = new EventEmitter();
  @Output() sendFilter = new EventEmitter<boolean>();
  @Output() here = new EventEmitter();
  @Input() data: any[];
  @Input() searchMap: any;
  @Input() langList: string;

  //@ViewChild(MapComponent) myLocation: MapComponent;
  //@ViewChild(MapComponent) searchLocation: MapComponent;
  //@ViewChild(MapComponent) filterArea: MapComponent;
  //@ViewChild(MapComponent) isWelcome: MapComponent;

  @ViewChild(MapComponent, { static: true }) myLocation: MapComponent;
  @ViewChild(MapComponent, { static: true }) searchLocation: MapComponent;
  @ViewChild(MapComponent, { static: true }) filterArea: MapComponent;
  @ViewChild(MapComponent, { static: true }) isWelcome: MapComponent;

  areas = [];
  showWelcome = true;
  lang;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.areas = this.data;
    if (isPlatformBrowser(this.platformId)) {
      const checkIsWelcome = sessionStorage.getItem("show-welcome");
      if (checkIsWelcome) {
        if (checkIsWelcome === "true") {
          this.showWelcome = true;
        } else {
          this.showWelcome = false;
        }
      } else {
        sessionStorage.setItem("show-welcome", "" + this.showWelcome);
      }
    }
  }

  ngOnChanges() {
    this.lang = this.langList;
  }

  ngAfterViewInit() {
    this.searchLocation.searchLocation(this.searchMap);
  }

  hiddenWelcome() {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("show-welcome", "false");
      this.showWelcome = false;
      this.isWelcome.getCurrentPosition();
    }
  }

  clickHere() {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem("show-welcome", "false");
      this.showWelcome = false;
      this.here.emit();
    }
  }

  filterReceive(event) {
    this.filterArea.filterArea(event);
  }

  getMyLocation() {
    this.myLocation.youAreHere();
  }
}
